export function Treeniohjelma() {
  return (
    <div className="container vitsit">
      <div>
        <h1>Wappu-urheilijan treeniohjelma</h1>
      </div>

      <p>
        Yhteen kauden päätavoitteista eli Waputtimeen osallistuminen vaatii
        soittajalta ja yleisöltä huolellista valmistautumista. Loppukauteen
        sijoittuvissa koitoksissa yleisenä haasteena on soittokunnon
        oikeanlaisen herkkyyden ylläpito. Ohessa on asiantuntijoidemme laatima
        suositus, jolla pidät oikeanlaisen vireen yllä finaaliin asti! Muista
        erityisesti huolehtia palauttavista pitkin viikkoa!
      </p>
      <p>
        Ma – Viimeinen pitkä harjoitus ennen keikkaa tavallisen viikkorytmin
        mukaisesti.
      </p>

      <p>Ti – Välipäivä, ota rauhassa. Aloita sunnuntain eväiden pohtiminen.</p>

      <p>
        Ke – Intervallitreeni: Aloita vierekkäisillä sävelaskelilla ja etene
        pikkuhiljaa isompiin hyppyihin. Kiinnitä huomiota tekniikan puhtauteen.
      </p>

      <p>
        To – Palautteleva treeni pienillä (esim. 0,33 kg) painoilla. Lämmittele
        asteikolla C-G ja venyttele äänihuulet. Varmista, että keikkapäivän
        evästarpeet löytyvät jääkaapista.
      </p>

      <p>
        Pe – Aamulenkki ja hyvät päiväunet. Iltaa kohden voi alkaa hakea kevyttä
        sykkeen nostoa, tähän auttaa hyvä harjoitusseura.
      </p>

      <p>La – Vireen ylläpito ja viime hetken kunnon kohotus.</p>

      <p>
        Su – Suorituspäivä. Muista pitää huolta sopivasta nesteytyksestä aamusta
        asti. Aamiainen, lounas ja päivällinen raikkaassa ulkoilmassa auttaa
        sopivan herkkyyden saavuttamisessa. Huomista ajatellen kannattaa laittaa
        hyvät palauttelueväät valmiiksi.
      </p>
    </div>
  );
}
